import type {
    GoogleRecaptchaRenderOptions,
    GoogleRecaptchaLibraryConfiguration,
} from '@indeed/bot-detection-multi-captcha-library';
import { GoogleRecaptchaWidget } from '@indeed/bot-detection-multi-captcha-library';

const recaptchaRenderOptions: GoogleRecaptchaRenderOptions = {
    sitekey: '6LfXKvsrAAAAAHSwLHE5B8rvjd56B6auHZAcfwrS',
    action: 'search',
    badge: 'inline',
    size: 'invisible',
    hideBadge: true,
};

const libraryConfiguration: GoogleRecaptchaLibraryConfiguration = {
    application: 'indeedMobile',
    appPageName: 'resultsPage',
};

const recaptchaWidget: GoogleRecaptchaWidget = new GoogleRecaptchaWidget(
    libraryConfiguration,
    recaptchaRenderOptions
);

// @ts-ignore
window.resultsPageRecaptcha = recaptchaWidget;
